export default "__VITE_ASSET__B2K6aKSU__"